// The languages with a /become-a-tutor page, and the ones that also have a
// /find-a-tutor page. Mirrors LanguagePagesController::TEACH_LANGUAGES and
// LEARN_LANGUAGES, the lists Rails server-renders and indexes;
// spec/frontend/language_pages_spec.rb fails when they drift. A page needs both
// its entry here and a Sanity doc. `learn: false` marks a language with a teach
// page only (no tutor to book yet, #1017). code/name are the catalog's
// (config/languages.yml), so languageDisplayName can label a link to the page.
export const LANGUAGE_PAGES = [
  { slug: "english", code: "en", name: "English" },
  { slug: "french", code: "fr", name: "French" },
  { slug: "spanish", code: "es", name: "Spanish" },
  { slug: "italian", code: "it", name: "Italian" },
  { slug: "japanese", code: "ja", name: "Japanese" },
  { slug: "portuguese", code: "pt", name: "Portuguese", learn: false },
] as const;

export type LanguagePageSlug = (typeof LANGUAGE_PAGES)[number]["slug"];
export type LanguagePageSide = "teach" | "learn";

// The pages of one side, in the list's order.
export function languagePagesFor(side: LanguagePageSide) {
  return LANGUAGE_PAGES.filter((page) => side === "teach" || !("learn" in page));
}

export function isLanguagePageSlug(slug: string, side: LanguagePageSide = "teach"): slug is LanguagePageSlug {
  return languagePagesFor(side).some((page) => page.slug === slug);
}
